const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = null;
      this.cartNotificationReady = false;
    }

    async getCartNotification() {
      // Return cached instance if already initialized
      if (this.cartNotificationReady && this.cartNotification) {
        return this.cartNotification;
      }

      // Find element in DOM
      const element = document.querySelector('cart-notification');
      if (!element) {
        console.warn('cart-notification element not found in DOM');
        return null;
      }

      // Wait for custom element to be defined (with 2 second timeout)
      try {
        await Promise.race([
          customElements.whenDefined('cart-notification'),
          new Promise((_, reject) => setTimeout(() => reject(new Error('timeout')), 2000))
        ]);
        
        // Element is now upgraded with its methods
        this.cartNotification = element;
        this.cartNotificationReady = true;
        return this.cartNotification;
      } catch (error) {
        console.warn('cart-notification custom element not registered:', error);
        return null;
      }
    }

    async onSubmitHandler(evt) {


      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');

      if (submitButton.classList.contains('loading')) return;

      console.log({submitButton});

      this.handleErrorMessage();
      
      // Get cart notification and ensure it's ready
      const cartNotification = await this.getCartNotification();
      
      if (cartNotification) {
        cartNotification.setActiveElement(document.activeElement);
      }

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (cartNotification) {
        const sectionsToRender = cartNotification.getSectionsToRender();
        const sections = sectionsToRender?.map((section) => section.id);
        if (sections && sections.length > 0) {
          formData.append('sections', sections.join(','));
        }
      } else {
        console.warn('No cart notification available, sections not added to request');
      }
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      // Get current quantity in cart (default to 0 if item not in cart)
      const variantId = formData.get('id');
      const currentQuantityInCart = window?.OVERSELLING?.cart_item_details?.[variantId] || 0;
      const newInventory = currentQuantityInCart + 1;
      
      // Check inventory availability (function is now always available via fallback in global.js)
      // Logging is done inside checkInventory function
      const isInventoryAvailable = window.checkInventory(variantId, newInventory);
      
      const productId = Number(formData.get('product-id'));
 
      if(!isInventoryAvailable && productId !== 4594128027721) {
        const availableQty = window?.OVERSELLING?.variant_inventory_details?.[variantId];
        if (availableQty !== undefined) {
          this.handleErrorMessage(`Sorry, only ${availableQty} units available for this item.`);
        } else {
          this.handleErrorMessage('Sorry, there is no units available for this item.');
        }
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        return;
      };

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then(async (response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          const boundThis = this

          if(window?.OVERSELLING?.cart_item_details){
            window.OVERSELLING.cart_item_details[response.variant_id] = response.quantity;
          }
          if (window.selectedWarranty && window.selectedWarranty.offer.cost === '0.00') {
            window.pdpModal.open();
             return;
           }

          const variantId = location.search.split('=')[1]

          if (window.selectedWarranty) {
            mulberryShop.getWarrantyVariant(window.selectedWarranty.offer)
            .then(async function(result) {
              window.productData.variantId = String(variantId);
              mulberryShop.addWarrantyToCart(result.shopify_variant_id, window.productData, window.selectedOffer)
              .then(async function() {
                await sleep(500);
                fetch('/cart.js')
                .then(function(res) {
                  return res.json()
                })
                .then(function(firstCart) {
                  return mulberryShop.removeDetachedWarranty(firstCart)
                })
                .then(function(secondCart) {
                  return mulberryShop.cart.syncQuantities(secondCart)
                })
                .then(async function(finalCart) {
                  /**
                   * TODO: If a Mulberry plan is added, it is not currently
                   * reflected in cartNotification.renderContents(response).
                   *
                   * You could change this by passing an updated `cart`
                   * object to renderContents(). However to do so, you would
                   * need to update cart-notification.js to handle our plans.
                   *
                   * const res = await fetch('/cart.js')
                   * const cart = await res.json()
                   * boundThis.cartNotification.renderContents(cart)
                  */
                   let cartHTML = await fetch('/cart?view=drawer');
                   let cartHTMLFinal = await cartHTML.text();
                   $('#cart-notification-product').html($(cartHTMLFinal).html());
                   const notification = await boundThis.getCartNotification();
                   if (notification) {
                     notification.renderContents(response);
                   } else {
                     console.warn('Cart notification not available for warranty flow');
                   }
                   mulberryShop.cart.render();
                })
              })
            })
            .catch((e) => {
              console.error(e)
            })
          } else {
            const notification = await this.getCartNotification();
            if (notification) {
              notification.renderContents(response);
            } else {
              console.warn('Cart notification not available for standard flow');
            }
          }

        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          updateOverselling();
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
